module.exports = __webpack_public_path__ + "img/wechatcode1.ff2e8c3b.png";